import { render, staticRenderFns } from "./DashboardFinanceiro.vue?vue&type=template&id=e50a5712&scoped=true&"
import script from "./DashboardFinanceiro.vue?vue&type=script&lang=js&"
export * from "./DashboardFinanceiro.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFinanceiro.vue?vue&type=style&index=0&id=e50a5712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50a5712",
  null
  
)

export default component.exports